import moment from 'moment-timezone';

/**
 * Sets the locale for Moment.js and handles dynamic locale file loading.
 * @param locale - The locale string (e.g., "en_US", "en-GB").
 * @param timeZone - The timezone string to set (optional).
 */
export const setMoment = (locale: string, timeZone?: string) => {
  const hasSubLocale = locale.includes('_') || locale.includes('-');
  const normalizedLocale = hasSubLocale ? locale.replace('_', '-').toLowerCase() : locale;

  try {
    if (timeZone) {
      moment.tz.setDefault(timeZone); // Set the timezone if provided
    }

    if (hasSubLocale && normalizedLocale.startsWith('en')) {
      require(`moment/locale/${normalizedLocale}`); // Dynamically load the sub-locale file
      moment.locale(normalizedLocale);
    } else {
      moment.locale('en'); // Set default to English if not English locale
    }
  } catch (error) {
    console.error(`Failed to set Moment.js locale: ${normalizedLocale}`, error);
  }
};

export const hasCurrentLocale12HourFormat = (): boolean => {
  const format = moment.localeData().longDateFormat('LT');
  return /(A|a)/.test(format);
};
